import v2026 from '@/sui/data/sheets/edit/toolsUsage/2026'

const result = {
  '2026': v2026.sheet
}

export default result
